// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2CjBS","errors":"Errors_errors__28K7x"};